import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setUnassignedJobOperations = (state, { unassignedJobsOperationData }) => {
  if (!unassignedJobsOperationData) return state;
  return state.merge({ unassignedJobsOperationData });
};

const setUnassignedJobOperationsLoaderStatus = (state, { unassignedJobOperationsLoader }) => {
  return state.merge({ unassignedJobOperationsLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_UNASSIGNED_JOBS_OPERATION,
    actionFunction: setUnassignedJobOperations,
  },
  {
    actionType: ActionTypes.SET_UNASSIGNED_JOBS_OPERATION_LOADER_STATUS,
    actionFunction: setUnassignedJobOperationsLoaderStatus,
  },
];
